const ModalTransactionCancel = () => {
    return (
        <div className="trans-updates">
            <img src="/img/payments/payment-cancel.svg" alt=""/>
            <span className="f-medium f-20 block m-lg-t">Your transaction could not be completed.</span>
            <div className="m-lg-t m-md-b">
                <span className="btn-solid bg-orange t-uppercase w-auto p-xxl-l p-xxl-r">Retry</span>
            </div>
        </div>
    );
};

export default ModalTransactionCancel;
